export default "__VITE_ASSET__DXbOGAWd__"